import { forwardRef, type ButtonHTMLAttributes } from 'react';
import { Icon, type IconName } from './icons/index.tsx';
import styles from './IconButton.module.css';

export interface IconButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  icon: IconName;
  /** Required: icon-only buttons need an accessible name. */
  label: string;
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(function IconButton(
  { icon, label, className, type = 'button', ...rest },
  ref,
) {
  return (
    <button
      ref={ref}
      type={type}
      aria-label={label}
      title={label}
      className={[styles['iconButton'], className ?? ''].filter(Boolean).join(' ')}
      {...rest}
    >
      <Icon name={icon} size="1.5rem" />
    </button>
  );
});
